import styled from '@emotion/styled';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const Title = styled.h1`
  font-family: 'FuturaStd';
  font-style: normal;
  font-weight: bold;
  font-size: ${30 / 16}rem;
  line-height: 22px;
  text-transform: capitalize;
`;
